<template>
  <div class="find-space-nav">
    <div>
        <div class="find-space-logo"><a href="/"><img src="/images/icons/logo-full-v2.svg"/></a></div>
    </div>
    <div class="find-space-nav-items">
        <template v-if="userType == 'hirer'">
            <div class="find-space-nav-link" :class="{ active: page == 'briefs'}" @click="goToBrief">Briefs</div>
            <div class="find-space-nav-link" :class="{ active: page == 'shortlists'}" @click="goToShortlists">Shortlists</div>
            <div class="find-space-nav-link" :class="{ active: page == 'bookings'}" @click="goToBookings">Bookings</div>
        </template>
        <template v-if="userType == 'lister'">
            <div class="find-space-nav-link" :class="{ active: page == 'listings'}" @click="goToListings">Listings</div>
            <div class="find-space-nav-link" :class="{ active: page == 'bookings'}" @click="goToBookings">Bookings</div>
        </template>
    </div>

    <div class="find-space-nav-end">
        <div class="find-space-account-btn" :class="{'lister-branding': userType == 'lister'}" @click="goToAccount" v-if="user">{{ user.first_name.substring(0,1) }}{{ user.last_name.substring(0,1) }}</div>
        <div class="find-space-mobile-menu" @click="openMenu" v-if="!publicView">
            <button type="button" class="transparent menu-trigger flex">
                <svg xmlns="http://www.w3.org/2000/svg" class="menu">
                    <image xlink:href="/images/icons/menu.svg" />
                </svg>
                MENU
            </button>
        </div>
        <div class="find-space-close-wrapper">
            <button
                type="button"
                class="circled interactive close-modal transparent-outline-white"
                @click="closeModal"
            >
                <svg-icon id="cross"></svg-icon>
            </button>
        </div>
    </div>
  </div>
</template>

<script>

export default {
    methods: {
        closeModal() {
            this.$emit('closeModal');
        },
        goToLogin() {
            this.closeModal();
            this.$store.commit("user/setShouldBeRedirectedToFindYourSpace", true);
            this.$store.commit("user/changeAuthMode", "login");
        },
        goToBrief() {
            if (!this.user) {
                return this.goToLogin();
            }
            this.$store.commit('findspace/navigateToSubpage', { page: 'briefs', subpage: 'home' })
        },
        goToShortlists() {
            if (!this.user) {
                return this.goToLogin();
            }
            this.$store.commit('findspace/navigateToSubpage', { page: 'shortlists', subpage: 'home' })
        },
        goToBookings() {
            if (!this.user) {
                return this.goToLogin();
            }
            this.$store.commit('findspace/navigateToSubpage', { page: 'bookings', subpage: 'home' })
        },
        goToListings() {
            if (!this.user) {
                return this.goToLogin();
            }
            this.$store.commit('findspace/navigateToSubpage', { page: 'listings', subpage: 'home' })
        },
        goToAccount() {
            this.$store.commit('findspace/navigateToSubpage', { page: 'account', subpage: 'account' })
        },
        openMenu() {
            this.$store.commit('account/navigateTo', { pane: 'overview', page: 'overview' })
        },
    },
    computed: {
        user () {
            return this.$store.getters['user/account']
        },
        page () {
            return this.$store.getters['findspace/page']
        },
        publicView() {
            return this.$store.getters['findspace/public']
        },
        userType() {
            return this.$store.getters['findspace/userType']
        }
    }
}
</script>
